import * as React from 'react';

import { UtilityService, UtilityServiceContext } from '../services';

interface WithUtilityService {
  utilityService: UtilityService;
}

export const withUtilityService = <ComposedComponentProps extends WithUtilityService>(ComposedComponent: React.ComponentClass<ComposedComponentProps>) => {
  type ComposedComponentInstance = InstanceType<typeof ComposedComponent>;

  type WrapperComponentProps = Omit<ComposedComponentProps, 'utilityService'>;
  type WrapperComponentPropsWithForwardedRef = WrapperComponentProps & {
    forwardedRef: React.Ref<ComposedComponentInstance>;
  };

  const WrapperComponent = ({ forwardedRef, ...rest }: WrapperComponentPropsWithForwardedRef) => {
    const context = React.useContext(UtilityServiceContext);

    return (
      <ComposedComponent
        ref={forwardedRef}
        // We need a cast because:
        // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/32355
        // https://github.com/Microsoft/TypeScript/issues/28938#issuecomment-450636046
        {...rest as unknown as ComposedComponentProps}
        utilityService={context}
      />
    );
  };

  return React.forwardRef<ComposedComponentInstance, WrapperComponentProps>((props, ref) => <WrapperComponent forwardedRef={ref} {...props} />);
}